import { atom } from 'recoil';
import { ATOMS_KEYS } from '../atom-keys';

export const controleBookingDetails = atom<boolean>({
	key: ATOMS_KEYS.CONTROLEBOOKINGDETAILS,
	default: false,
});
